import { useState, useEffect, useCallback } from 'react';

interface Props {
  sliderRef: React.MutableRefObject<HTMLDivElement | null>
  momentumVelocity?: number
  reliants?: any[]
}

function useDragScroll({
  sliderRef,
  reliants = [],
  momentumVelocity = 0.9,
}: Props) {
  const [isSwiping, setIsSwiping] = useState(false);

  const init = useCallback(() => {
    const slider = sliderRef.current;
    let isDown = false;
    let startX: number;
    let scrollLeft: number;

    if (slider) {
      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        cancelMomentumTracking();
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
        beginMomentumTracking();
        setTimeout(() => setIsSwiping(false), 0);
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3; // scroll-fast
        const prevScrollLeft = slider.scrollLeft;
        slider.scrollLeft = scrollLeft - walk;
        velX = slider.scrollLeft - prevScrollLeft;
        if (slider.scrollLeft - prevScrollLeft && !isSwiping) {
          setIsSwiping(true);
        }
      });

      slider.addEventListener('wheel', () => {
        cancelMomentumTracking();
      });
    }

    // Momentum
    let velX = 0;
    let momentumID: number;

    function beginMomentumTracking() {
      cancelMomentumTracking();
      momentumID = window.requestAnimationFrame(momentumLoop);
    }
    function cancelMomentumTracking() {
      window.cancelAnimationFrame(momentumID);
    }
    function momentumLoop() {
      if (slider) {
        slider.scrollLeft += velX;
        velX *= momentumVelocity;
        if (Math.abs(velX) > 0.5) {
          momentumID = window.requestAnimationFrame(momentumLoop);
        }
      }
    }

    return () => {
      if (slider) {
        slider.removeEventListener('wheel', () => {});
      }
    };
  }, []);

  useEffect(() => init(), [...reliants]);

  return {
    isSwiping,
  };
}

export default useDragScroll;
